import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { TextField, Checkbox } from 'redux-form-material-ui'
import { reduxForm, change, Field, formValueSelector, reset } from 'redux-form'
import autobind from 'autobind-decorator'
import Dropzone from 'react-dropzone'
import {createStyles, WithStyles, Theme, Grid, Icon, withStyles, FormControlLabel} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import { config } from 'src/conf/config'
import { IDocument } from 'src/type/document'
import { Validator } from 'src/core/form/Validator'
import { getFileExtension } from 'src/shared/utils/helpers'
import CategoriesKycSelect from 'src/shared/CategoriesSelect/CategoriesKycSelect'

const acceptedDocuments = ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pps,.ppsx,.pdf,.txt,.xml"

const styles = (t: Theme) => createStyles({
    dropzoneCustom :{
        width: '100%',
        height: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px dashed #ddd',
        textAlign: 'center',
        cursor: 'pointer',
    },
    filePreviewWpr: {
        position: 'relative',
        display: 'inline-block',
        paddingTop: '10px',
        overflow: 'visible'
    },
    filePreviewRemove: {
        position: 'absolute',
        top: 0,
        right: '-8px',
        background: 'rgba(0,0,0,0.8)',
        color: t.palette.common.white,
        fontSize: '1.2rem',
        borderRadius: '50%',
        boxShadow: t.shadows[2],
        cursor: 'pointer'
    }
})

const validate = values => Validator.build(values, {
    document: [Validator.required],
    categories: [Validator.required]
});

interface IProps extends WithI18n,
    ReturnType<typeof state2props>,
    ReturnType<typeof dispatch2props>,
    WithStyles<typeof styles> {
  dispatch: any;
  onSubmit: any;
  initialValues?: any;
  documentToUpload: any;
  uploadDocument: any;
}

interface IStates{
    isNewFileAdded: boolean;
}

class KycForm extends React.Component<IProps, IStates> {
    state = {
        isNewFileAdded: false,
    };

    render(){
        const {t, classes, onSubmit, documentToUpload} = this.props
        const {isNewFileAdded} = this.state
        return(
            <form onSubmit={onSubmit}>
                <Grid container>
                    {!isNewFileAdded &&
                        <>
                            <Grid item xs={12} style={{display:'flex', justifyContent: 'center'}}>
                                <Dropzone
                                    onDrop={this.onDropNewFile}
                                    multiple={false}
                                    className={classes.dropzoneCustom}
                                    maxSize={42000000}
                                    accept={acceptedDocuments}
                                >
                                    <div>
                                        <Icon style={{fontSize: "50px", color: "rgba(0, 0, 0, 0.54)"}}>cloud_download</Icon>
                                        <p>{t.chooseFile}</p>
                                    </div>
                                </Dropzone>
                                <Field name="document" component={TextField} type="hidden" style={{display: 'none'}}/>
                            </Grid>
                        </>
                    }
                    {isNewFileAdded &&
                        <>  
                            <Grid item xs={12}>
                                <div className={classes.filePreviewWpr}>
                                    <Icon onClick={this.removeFile} className={classes.filePreviewRemove}>close</Icon>
                                    {!!documentToUpload && this.getFilePreview(documentToUpload)}
                                </div>
                                <div>
                                    {t.Documents_file_name}
                                    <br/>
                                    <b>{!!documentToUpload ? documentToUpload!.name : documentToUpload}</b>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    name="categories"
                                    component={CategoriesKycSelect}
                                    label={t.categories}
                                    fullWidth={true}
                                    categoriesDispo={["type-de-document"]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Field
                                            name="must_be_signed"
                                            component={Checkbox}
                                        />
                                    }
                                    label={t.Document_must_be_signed}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </form>
        )
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const {isNewFileAdded} = this.state
        if(prevState.isNewFileAdded !== isNewFileAdded && !!isNewFileAdded){
            this.props.setValue("must_be_signed", true)
        }
        if(prevProps.documentToUpload !== this.props.documentToUpload && !this.props.documentToUpload){
            this.setState({isNewFileAdded: false});
            this.props.setValue("document", null)
            this.props.setValue("categories", null)
        }
    }
    @autobind
    private removeFile(){
        this.props.uploadDocument(null)
        this.setState({isNewFileAdded: false});
        this.props.setValue("document", null)
        this.props.setValue("categories", null)
        this.props.resetForm()
    }

    @autobind
    private getFilePreview(file){
        const images = ["jpg", "jpeg", "png"];
        const extensionFile = getFileExtension(file.name);
        if(images.indexOf(extensionFile) > -1){
            return (
                <img
                    src={file.preview}
                    className="img-responsive"
                    style={{"maxHeight": "100px"}}
                    alt="preview"
                />
            )
        } else {
            const extension = getFileExtension(file.name);
            return (
                <img
                    src={config.baseUrl + "/assets/images/file-type/" + extension + ".png"}
                    className="img-responsive"
                    alt="Extension"
                />
            )
        }
    }

    @autobind 
    private onDropNewFile(acceptedFiles, rejectedFiles){
        this.props.setValue("must_be_signed", false)
        const { dispatch} = this.props;
        if(acceptedFiles.length > 0){
            this.props.uploadDocument(acceptedFiles[0])
            this.setState({isNewFileAdded: true});
            this.props.setValue("document", acceptedFiles[0])
            dispatch(change(formName, "name", acceptedFiles[0].name));
        }
        if(rejectedFiles.length > 0){
            // do something
        }
    }
}

const formName = 'documentSendForm'

const state2props = (state, props) => ({
    mustBeSigned: formValueSelector(formName)(state, 'must_be_signed'),
    docCategories: formValueSelector(formName)(state, 'categories'),
    categories: state.categories.entities,
});

const dispatch2props = (dispatch: any) => ({
    resetForm: () => dispatch(reset(formName)),
    setValue: (field, value) => dispatch(change(formName, field, value)),
});

export default compose(
    withI18n,
    withStyles(styles),
    connect(state2props, dispatch2props)
)(reduxForm<IDocument, IProps>({
    form: formName,
    validate
})(KycForm))


// WEBPACK FOOTER //
// ./src/page/Consumer/Kyc/KycForm.tsx